import { useStore } from 'reactflow'
import { useNodePresentation } from '../../NodePresentationContext'

interface ViewportZoomStoreSnapshot {
  transform: [number, number, number]
}

export function getViewportZoom(store: ViewportZoomStoreSnapshot): number {
  return store.transform[2] ?? 1
}

export function useViewportZoom(): number {
  const presentation = useNodePresentation()
  const zoom = useStore(getViewportZoom)
  return presentation === 'detail' || presentation === 'list' ? 1 : zoom
}
